<div #introductionLayout class="introduction-layout">
  <div class="introduction-container">
    <div class="introduction-logo">
      <img src="assets/imgs/logo.png" alt="ПВЗ Админ" />
    </div>

    <div
      class="introduction-content"
      [class.introduction-content--actions-fixed]="isActionsFixed"
    >
      <div class="introduction-header">
        <div class="introduction-title">Документы для подтверждения</div>
        <div class="introduction-subtitle">Ознакомьтесь и подтвердите согласие с документами ниже</div>
      </div>

      <div class="introduction-message">
        <pa-message
          severity="info"
          icon="pi pi-info-circle"
          size="small"
          text="Полный список документов для ознакомления всегда доступен в разделе «Документы»."
        />
      </div>

      @if (isDocumentsLoading) {
        <div class="introduction-documents-list">
          <div class="introduction-document-card introduction-document-card--skeleton" *ngFor="let _ of [1, 2, 3, 4, 5, 6]">
            <div class="introduction-document-card__title skeleton-animation"></div>
            <div class="introduction-document-card__meta">
              <div class="introduction-document-card__tag-skeleton skeleton-animation"></div>
            </div>
          </div>
        </div>
      } @else {
        <div class="introduction-documents-list">
          <div
            class="introduction-document-card"
            *ngFor="let document of documents"
            (click)="openDocumentModal(document)"
          >
            <div class="introduction-document-card__title">{{ document.name }}</div>
            <div class="introduction-document-card__meta">
              <pa-tag
                [value]="
                  isIntroductionAgreed(document)
                    ? 'Согласен'
                    : 'Требует согласия'
                "
                [severity]="
                  isIntroductionAgreed(document) ? 'success' : 'warn'
                "
              ></pa-tag>
            </div>
          </div>
        </div>
      }

      <div
        class="introduction-actions"
        [class.introduction-actions--fixed]="isActionsFixed"
      >
        @if (isDocumentsLoading) {
          <div class="introduction-actions__checkbox-skeleton skeleton-animation"></div>
          <div class="introduction-actions__button-skeleton skeleton-animation"></div>
        } @else {
          @if (!isAllConfirmed) {
            <div class="introduction-actions__checkbox">
              <p-checkbox
                inputId="intro-agree"
                size="small"
                [binary]="true"
                (onChange)="onIntroAgreeCheckedChange()"
                [(ngModel)]="introAgreeChecked"
              >
              </p-checkbox>
              <label for="intro-agree">Я согласен(а)</label>
            </div>
          }
          <pa-button
            [label]="'Продолжить'"
            [severity]="'primary'"
            [disabled]="isContinueDisabled"
            (click)="onContinue()"
          ></pa-button>
        }
      </div>
    </div>
  </div>
</div>


<p-confirmdialog />